import { Button, Modal } from 'react-bootstrap';
import React from 'react';
import CourseService from '../../service/courseService'
import useToken from '../../App/useToken';

import './ClearStudentCourseModal.css'

export default function ClearStudentCourseModal({ showClearStudentCourseModal, setShowClearStudentCourseModal, courseId, getStudentCourse }) {
    const { getToken } = useToken();
    const token = getToken();
  
    const handleClose = () => {
      setShowClearStudentCourseModal(false);
    }

    const handleOnClearStudentCourse = async e => {
      const courseService = new CourseService();
      const res = await courseService.clearStudentCourse(courseId, token);
      if (res) {
        setShowClearStudentCourseModal(false)
        getStudentCourse();
      }
    }
    return (
      <>
        <Modal
            show={showClearStudentCourseModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
              <Modal.Header closeButton>
                <Modal.Title>ล้างข้อมูล</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                คุณต้องการล้างข้อมูลหลักสูตร(wording for confirm to delete)?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  ปิด
                </Button>
                <Button variant="primary" type='submit' onClick={handleOnClearStudentCourse}>บันทึก</Button>
              </Modal.Footer>
        </Modal>
      </>
    );
}